import { useEffect, useState } from "react";
// styled components
import { Form, Input, Select, Button, Table, Empty, Popover } from "antd";
// components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalEditarDocumentacionGeneral } from "./ModalEditarDocumentacionGeneral";
// icons
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
// hooks
import { useDocumentacionGeneral } from "../../../../hooks/useDocumentacionGeneral";

// another files
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import { useNavigate } from "react-router-dom";
import { useMaestras } from "../../../../hooks/useMaestras";
import { ModalEliminarDocumentosGenerales } from "./ModalEliminarDocumentosGenerales";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import DocumentInput from "../../../../utils/DocumentInput";
import ModalWarning from "../../../../utils/Alerts/ModalWarning";

export const DocumentacionConvocatoria = () => {
  const navigate = useNavigate();
  const { decrypt } = useEncrypt();
  const [modal_war, setModal_war] = useState(false);
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // hook
  const {
    cargarDocumentosGenerales,
    documento,
    setDocumento,
    documentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    eliminarFila,
    guardarycontinuar,
    setDocumentos,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisulizar,
    modaleditardocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento,
    setGuardoArchivo,
    modaleliminar,
    setModaleliminar,
    nombreDocumento,
    setNombreDocumento,
    loading,
  } = useDocumentacionGeneral();

  const { documentosGenerales, obtenerDocGen } = useMaestras();

  useEffect(() => {
    cargarDocumentosGenerales();
    obtenerDocGen();
  }, []);

  // fields
  const fields = [
    { name: "nombre", value: documento.nombre },
    { name: "tipo_documento", value: documento.tipo_documento },
    { name: "descripcion", value: documento.descripcion },
    { name: "url_documento", value: documento.url_documento },
  ];
  // columnas
  const columns = [
    {
      title: "No.",
      width: 60,
      render: (data: any, data2: any, index: number) => {
        return (
          <span className="font-family-Montserrat-Regular">{index + 1}</span>
        );
      },
    },
    {
      title: "Tipo de documento",
      width: 200,
      dataIndex: "tipo_documento",
      key: "tipo_documento",
    },
    {
      title: "Nombre",
      width: 200,
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Nombre archivo",
      width: 200,
      dataIndex: "url_documento",
      key: "url_documento",
    },
    {
      title: "Descripción",
      width: 200,
      dataIndex: "descripcion",
      key: "descripcion",
      render: (datos: any) => {
        return (
          <>
            {datos.length > 27 ? (
              <Popover content={datos} title="Descripción">{`${datos.substring(
                0,
                24
              )}...`}</Popover>
            ) : (
              datos
            )}
          </>
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Acciones</div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 200,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <EyeOutlined
                  onClick={() => {
                    if (datos.url_documento !== "") {
                      setDocumentoVisulizar(datos.url_documento);
                      setModalVisualizarDocumento(true);
                    } else {
                      setModal_war(true);
                    }
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <EditOutlined
                  onClick={() => {
                    setIndexDocumento(index);
                    setModalEditarDocumento(true);
                    setDocumento(datos);
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <DeleteOutlined
                  onClick={() => {
                    setIndexDocumento(index);
                    setNombreDocumento(datos.url_documento);
                    return setModaleliminar(true);
                  }}
                />
              }
            ></Button>
          </div>
        </div>
      ),
    },
  ];

  const routes = [{ nombre: "Crear convocatoria" }];
  const onAceptar = () => {
    return setModal_war(false);
  };

  return (
    <div className="background-color-F7FBFF height-100">
      <BreadCrumbAdmin routes={routes} />

      <Navegador idconvocatorias={idConvocatoria} activo="Doc. general" />
      <div
        className="container-fluid ps-md-4 pe-md-4 main-c3"
        style={{ marginBottom: "20px" }}
      >
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Documentación general convocatoria
        </div>
        <div className="sombra_card">
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
              <div className="row">
                <div className="col-12 col-md-8 p-2 pt-0 font-size-14px font-family-Montserrat-Regular">
                  Agregar documentos
                </div>
                <div className="col-12 col-md-4 p-2 pt-0 justify-content-flex-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                  Código de convocatoria: {idConvocatoria}
                </div>
              </div>
            </div>
          </div>
          <Form
            name="documentosconvocatoriajurados"
            size="large"
            layout="vertical"
            onFinish={agregarfila}
            fields={fields}
            onFieldsChange={(_, fields: any) => {
              let infoupdate: any = { ...documento };
              for (const i in fields) {
                infoupdate[fields[i].name] = fields[i].value;
              }
              setDocumento(infoupdate);
            }}
          >
            <div className="body_card">
              <div className="row">
                <div className="col-12 col-md-3">
                  <Form.Item
                    className="no-margin"
                    label="Nombre"
                    name="nombre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-3">
                  <Form.Item
                    className="no-margin"
                    label="Tipo de documento"
                    name="tipo_documento"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select placeholder="Seleccionar...">
                      {documentosGenerales.map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={nombre}>
                          {nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                  <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353 mt-1">
                    Adjuntar documento
                  </span>
                  <DocumentInput
                    doc={documento.url_documento}
                    fileInputRef={fileInputRef}
                    tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                    setGuardoArchivo={setGuardoArchivo}
                    on_change={(e) => {
                      setGuardoArchivo(true);
                      guardarArchivo(e);
                      e.target.value = "";
                    }}
                    onDelete={async () => {
                      setDocumento({
                        ...documento,
                        url_documento: "",
                      });
                    }}
                  />
                </div>

                <div className="col-12 col-md-12">
                  <Form.Item
                    className="no-margin"
                    label="Descripción"
                    name="descripcion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input.TextArea maxLength={300} showCount={true} />
                  </Form.Item>
                </div>
                <div className="col-12">
                  <Button
                    className="button-azul-radius float-end"
                    htmlType="submit"
                    form="documentosconvocatoriajurados"
                  >
                    Agregar
                  </Button>
                </div>
                <div className="col-12 font-size-14px font-family-Montserrat-Regular">
                  Documentación general asociadas
                </div>
                <div className="col-12">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4" }}
                    locale={{
                      emptyText: (
                        <Empty
                          description="No se han diligenciados datos para está sección"
                          style={{ padding: "50px" }}
                        />
                      ),
                    }}
                    size="small"
                    rowClassName="sizeTable table-row"
                    columns={columns}
                    dataSource={documentos}
                    bordered={false}
                    pagination={false}
                  />
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <div className="container-sticky-footer d-flex justify-content-between align-items-center" style={{ padding: 20 }}>
          <div className="justify-content-flex-start align-content-center">
            <Button className="button-blanco-radius m-0" onClick={() => navigate("/administrador/documentacionTecnica")}>
              Atrás
            </Button>
          </div>
          <div className="justify-content-flex-end">
            <Button
              className="button-azul-radius m-0"
              onClick={guardarycontinuar}
              disabled={loading}
            >
              Guardar y continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
      </div>

      <ModalEliminarDocumentosGenerales
        nombre={nombreDocumento}
        modal={modaleliminar}
        cancelar={() => {
          setModaleliminar(false);
        }}
        indexDocumentacion={indexdocumento}
        eliminar={() => eliminarFila(indexdocumento)}
      />

      <ModalVisualizarDocumentos
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
        state={{ documento: documentovisualizar }}
      />
      <ModalEditarDocumentacionGeneral
        visualizar={modaleditardocumento}
        setVisualizar={setModalEditarDocumento}
        documento={documento}
        setDocumento={setDocumento}
        documentos={documentos}
        setDocumentos={setDocumentos}
        indexdocumento={indexdocumento}
      />
      <ModalWarning
        visualizar={modal_war}
        setVisualizar={setModal_war}
        onAceptar={onAceptar}
        titlle="Visualización de documento"
        description="Sin documento Adjunto"
        subdescription="Este registro no contiene un documento adjunto."
      />
    </div>
  );
};
